/* eslint-disable react/jsx-props-no-spreading */
import { Circle, CircleProps, Icon, Tooltip } from '@chakra-ui/react';

import { Pencil } from '@/client/components/icons/ContinuIcons';

interface CircleEditButtonProps extends Omit<CircleProps, 'children'> {
  tooltipLabel?: string;
  icon?: React.ElementType;
  onClick: () => void;
  colorScheme?: 'white' | 'neutral';
}

export default function CircleEditButton({
  tooltipLabel,
  icon,
  onClick,
  colorScheme = 'white',
  ...props
}: CircleEditButtonProps) {
  const colorSchemeStyleMap = {
    white: {
      borderColor: 'white',
      color: 'white',
      _hover: {
        cursor: 'pointer',
        backgroundColor: 'rgba(255, 255, 255, 0.35)',
      },
    },
    neutral: {
      borderColor: 'neutral.100',
      color: 'neutral.900',
      _hover: {
        cursor: 'pointer',
        backgroundColor: 'neutral.0',
      },
    },
  };

  const colorSchemeStyle = colorSchemeStyleMap[colorScheme];

  return (
    <Tooltip label={tooltipLabel}>
      <Circle
        border="1.5px solid"
        borderColor={colorSchemeStyle.borderColor}
        size={8}
        onClick={onClick}
        transition="background-color 400ms"
        _hover={colorSchemeStyle._hover}
        {...props}
      >
        <Icon as={icon || Pencil} color={colorSchemeStyle.color} boxSize={3} />
      </Circle>
    </Tooltip>
  );
}
